// Use relative URLs for production deployment where nginx serves both frontend and API
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "";
export const REACT_APP_I18_LANG = process.env.REACT_APP_I18_LANG;
export const REACT_APP_FRONTEND_ROOT = process.env.REACT_APP_FRONTEND_ROOT;
export const API_BASE_URL = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/api`
  : "/api";

export const WEB_REPORT_TOKEN =
  process.env.REACT_APP_WEB_REPORT_TOKEN || "default-web-token";

export const APP_VERSION = "4.6.3";
